module.exports = __webpack_public_path__ + "static/media/Card_Flea.6a9972f1.svg";